<template>
  <div>
    <div class="page-body">
      <console-totals></console-totals>
      <console-warnings style="margin-top:20px"></console-warnings>
      <el-card header="新风节能和运行情况" style="margin-top: 20px">
        <el-row :gutter="20">
          <el-col :span="8">
            <console-chart1 :year="year"></console-chart1>
          </el-col>
          <el-col :span="8">
            <console-chart2 :year="year"></console-chart2>
          </el-col>
          <el-col :span="8">
            <console-chart3 :year="year"></console-chart3>
          </el-col>
          <el-col :span="8">
            <console-chart4 :year="year"></console-chart4>
          </el-col>
          <el-col :span="8">
            <console-chart5 :year="year"></console-chart5>
          </el-col>
          <el-col :span="8">
            <console-chart6 :year="year"></console-chart6>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";
import ConsoleTotals from "@/components/console/ConsoleTotals";
import ConsoleWarnings from "@/components/console/ConsoleWarnings";
import ConsoleChart1 from "@/components/console/ConsoleChart1";
import ConsoleChart2 from "@/components/console/ConsoleChart2";
import ConsoleChart3 from "@/components/console/ConsoleChart3";
import ConsoleChart4 from "@/components/console/ConsoleChart4";
import ConsoleChart5 from "@/components/console/ConsoleChart5";
import ConsoleChart6 from "@/components/console/ConsoleChart6";

export default {
  name: "Console",
  components: {
    ConsoleChart6,
    ConsoleChart5, ConsoleChart4, ConsoleChart3, ConsoleChart2, ConsoleChart1, ConsoleWarnings, ConsoleTotals},
  extends: BaseVue,
  data() {
    return {
      year: new Date().getFullYear()
    }
  },
  created() {

  }
}
</script>

<style lang="scss" scoped>

</style>